import * as React from 'react';
import BlogPage from "@components/Blog";
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { StoreState, Blog } from '@store/index';
import { withRouter, RouteComponentProps } from 'react-router-dom';

export interface Props extends RouteComponentProps { 
    blogs: Blog[];
    technologies: string[];
}

const BlogContainer: React.SFC<Props> = (props: Props) => {
    const { blogs, technologies, location } = props;
    const title = 'Blog - Nick Avasiloi | Full Stack Web Developer, Artificial Intelligence Specialist';
    const description = 'Blog posts over Artificial Intelligence algoritms and techniques';
    const url = process.env.REACT_APP_URL + props.location.pathname;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta name="og:title" content={title} />
                <meta name="og:description" content={description} />
                <meta name="og:url" content={url} />
            </Helmet>
            <BlogPage blogs={blogs} technologies={technologies} location={location} />
        </>
    );
}

const BlogContainerConnected = connect<{}, {}, Props>(
    (state: StoreState) => {
        const { blogs, technologies } = state;
    
        return { blogs, technologies: technologies.blog }
    }
)(BlogContainer);

const BlogContainerRouted = withRouter(BlogContainerConnected);

export default BlogContainerRouted;



// WEBPACK FOOTER //
// ./src/containers/Blog/index.tsx